import { EventBus } from "../../../eventbus";
import uniqid from "uniqid";

export default {
  props: {
    name: String,
    options: Array,
    icon: String,
    disabled: Boolean,
    setName: Boolean,
    hasInput: Boolean,
    type: String,
    size: String,
  },
  data() {
    return {
      id: uniqid(),
      open: false,
      activeName: "",
      filteredOptions: [],
    };
  },
  created() {
    this.activeName = this.name;

    this.filteredOptions = this.options;

    EventBus.$on("vdropdown--close-all", (currentId) => {
      if (currentId !== this.id) {
        this.open = false;
      }
    });
  },
  methods: {
    toggleDropDown() {
      this.open = !this.open;
      const input = this.$refs.filterInput;

      if (this.open) {
        //close others
        EventBus.$emit("vdropdown--close-all", this.id);
      }

      if (input) {
        if (this.open) {
          input.select();
        } else {
          input.blur();
        }
      }
    },
    setOpen(status) {
      this.open = status;
    },
    handleClickOption(e, func, name) {
      this.open = false;
      if (this.setName) {
        this.activeName = name;
      }

      if (func) {
        func(e);
      }
    },

    filterOptions(e) {
      const value = e.currentTarget.value;

      this.activeName = value;

      this.filteredOptions = this.options.filter((option) =>
        option.name.toLowerCase().includes(value.toLowerCase())
      );
    },
  },
  watch: {
    disabled() {},
    options() {},
  },
};
